const labels = {
  ready: 'Head gestures active',
  away: 'Look at camera for head gestures',
  missing: 'Look at camera for head gestures',
  hand: 'Hand controls active',
  'hand-ignored-distance': 'Hand too far away · ignored',
  'hand-ignored-background': 'Hand behind closest face · ignored',
  'multiple-faces': 'Multiple faces · gestures ignored',
  'multiple-hands': 'Multiple hands · gestures ignored',
  'multiple-subjects': 'Multiple faces & hands · gestures ignored',
  'multiple-faces-focused': 'Multiple faces · closest selected',
  'multiple-hands-focused': 'Multiple hands · closest selected',
  'multiple-subjects-focused': 'Multiple faces & hands · closest selected',
};

export class GestureStatus extends HTMLElement {
  constructor() { super(); this.attachShadow({mode:'open'}); }
  connectedCallback() {
    this.shadowRoot.innerHTML = `<style>
      :host{display:inline-flex;max-width:100%;--status-color:var(--accent,#dfb77a)}
      :host([hidden]){display:none}:host([data-state=ready]),:host([data-state=hand]){--status-color:var(--green,#7d9787)}
      :host([data-state^="multiple-"]),:host([data-state^="hand-ignored-"]){--status-color:var(--danger,#ab4d40)}
      .badge{display:flex;align-items:center;justify-content:center;gap:7px;border:1px solid color-mix(in srgb,var(--status-color) 35%,transparent);border-radius:9px;padding:5px 9px;background:color-mix(in srgb,var(--status-color) 8%,transparent);color:var(--text,#28312e);font:500 10px/1.4 var(--font,system-ui);text-align:center}
      .dot{width:5px;height:5px;flex:none;background:var(--status-color);border-radius:50%}
      :host([compact]) .badge{border:0;padding:2px 4px;background:none;font-size:9px;gap:4px}
    </style><span class="badge"><span class="dot" aria-hidden="true"></span><span class="label"></span></span>`;
    this.setAttribute('role','status'); this.setAttribute('aria-live','polite'); this.setAttribute('aria-atomic','true');
    this.update(this.state || 'missing');
  }
  update(state) {
    this.state = state; this.dataset.state = state;
    const label = this.shadowRoot.querySelector('.label'), description = labels[state] || labels.missing;
    const compact = this.hasAttribute('compact');
    const text = compact && state.startsWith('multiple-') ? `2+ · ${state.endsWith('-focused') ? 'closest' : 'ignored'}`
      : compact && state === 'hand-ignored-distance' ? 'Too far'
      : compact && state === 'hand-ignored-background' ? 'Behind face' : description;
    if (this.title !== description) { this.title = description; this.setAttribute('aria-label', description); }
    if (label && label.textContent !== text) label.textContent = text;
  }
}
customElements.define('mt-gesture-status',GestureStatus);
